export default __webpack_public_path__ + "92b5b07b694ef901d106fa4dda4c4d25.ply";